(function (factory) {
	if (typeof module !== "undefined" && module.exports) {
		module.exports = factory;
	} else {
		factory(jQuery, window, document);
	}
}(function ($) {
	$.id_embedVideo = function (el, options) {
		const _this = this,
			$element = $(el);
		this.$template = null;
		this.videoSrc = null;
		this.$closeBtn = null;
		this.mouseHasMoved = false;
		this.init = function () {
			this.options = $.extend({}, $.id_embedVideo.defaultOptions, options);
			if ($element.data('src') === '' || !$element.data('src')) {
				console.log('ERROR: no data-src in link! cannot play video.');
				return;
			} else {
				this.videoSrc = $element.data('src');
			}
			this.$template = $('<div id="id_embedVideo"><div class="player"><a class="player-close"></a><div class="video-wrapper"><div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="' + this.videoSrc + '" allowfullscreen></iframe></div></div></div></div>');
			$element.off('click').on('click', function (e) {
				e.preventDefault();
				_this.openPlayer();
			});

		};
		/**
		 *
		 */
		this.openPlayer = function () {
			// attache modal to body
			this.$template
				.prependTo('body')
				.css('top', $(window).scrollTop())
				.off('click').on('click', function (e) {
				_this.closePlayer();
			});
			// small timeout for class animation
			setTimeout(function () {
				_this.$template.addClass('open');
			}, 100);
			// define $closeBtn
			this.$closeBtn = this.$template.find('a.player-close');

			// add events
			this.$closeBtn.off('click').on('click', function (e) {
				_this.closePlayer();
			});
			this.mouseHasMoved = false;
			this.startMouseMoveTimeout();
			this.$template.off('mousemove').on('mousemove', function (e) {
				if (!_this.mouseHasMoved) {
					_this.mouseHasMoved = true;
					_this.fadeInterface();
				}
			});
			// close player on ESCAPE
			$(document).off('keyup').on('keyup', function (e) {
				if (e.keyCode === 27) _this.closePlayer();
			});
		};

		this.fadeInterface = function () {
			if (!_this.mouseHasMoved) {
				_this.$closeBtn.addClass('faded');
				_this.$template.addClass('faded');
				_this.clearMouseMoveInterval();
			} else {
				_this.$closeBtn.removeClass('faded');
				_this.$template.removeClass('faded')
				_this.mouseHasMoved = false;
				_this.startMouseMoveTimeout();
			}
		}



		/**
		 *
		 */
		this.startMouseMoveTimeout = function () {
			clearInterval(this.mousemoveTimer)
			this.mousemoveTimer = setTimeout(this.fadeInterface, 3000);
		};

		/**
		 *
		 */
		this.clearMouseMoveInterval = function () {
			clearTimeout(this.mousemoveTimer);

		};

		/**
		 *
		 */
		this.closePlayer = function () {
			this.$closeBtn.removeClass('open faded');
			this.$closeBtn = null;
			this.$template.removeClass('open')
				.delay(400)
				.remove();
			clearInterval(this.mousemoveTimer);
			this.$template.off('mousemove')
		};
		this.init();
	};

	$.id_embedVideo.defaultOptions = {};

	$.fn.id_embedVideo = function (options) {
		return this.each(function () {
			(new $.id_embedVideo(this, options));
		});
	};
}));
